import React from "react";
import { Switch, RouteComponentProps } from "react-router-dom";
import { AppChangelogScreen } from "screens/AppChangelogScreen";
import { ProtectedRoute } from "./ProtectedRoute";

export function AppChangelogRouter({ match: { url } }: RouteComponentProps) {
  return (
    <Switch>
      <ProtectedRoute exact path={`${url}/`}>
        <AppChangelogScreen />
      </ProtectedRoute>
    </Switch>
  );
}
